export const LV_PermissionTR={
PermID:{en:'PermID',cs:'PermID',dataType:'number',format:'#0',required:true},
PermName:{en:'PermName',cs:'PermName',dataType:'string',required:true,maxLength:255},
PermNameCaption:{en:'PermNameCaption',cs:'PermNameCaption',dataType:'string',maxLength:255}
}